export default "__VITE_ASSET__f4df9380__"